import { Component, OnInit, Input } from '@angular/core';
import { Flight } from 'src/app/core/models/itinerary.model';
import { AirportIconsService } from 'src/app/search-result/services/airport-icons.service';

@Component({
  selector: 'app-flight-header-travel',
  templateUrl: './flight-header-travel.component.html'
})
export class FlightHeaderTravelComponent implements OnInit {
  @Input() flight: Flight;
  @Input() index: number;

  constructor(private icons: AirportIconsService) {}

  ngOnInit() {
    this.flight = this.icons.setIconFlight(this.flight);
  }
}
